import { render } from "./GetQuoteView.vue?vue&type=template&id=6489414b&scoped=true"
import script from "./GetQuoteView.vue?vue&type=script&lang=js"
export * from "./GetQuoteView.vue?vue&type=script&lang=js"

import "./GetQuoteView.vue?vue&type=style&index=0&id=6489414b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6489414b"]])

export default __exports__